<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Data SKP Peserta
    </CCardHeader>
    <!-- Data BPK -->
    <CCardBody>
      <CRow class="mb-3">
          <div class="col-sm-12 col-xl-12">
            <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Kategori Pelatihan</label>
              <select name="" id="" class="form-control" v-model="kategoriPelatihan" @change="getPelatihan()">
                <option value="" selected disabled>Pilih Kategori Pelatihan</option>
                <option value="lms">Pelatihan LMS</option>
                <option value="webinar">Pelatihan Webinar</option>
                <option value="offline">Pelatihan Offline</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-xl-12">
            <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Pelatihan</label>
              <multiselect
                class="mulit-select"
                label="nama_pelatihan"
                placeholder="Pilih pelatihan"
                id="pelatihanSelect"
                :show-labels="false"
                required
                v-model="pelatihan"
                :options="dataPelatihan"
                :custom-label="customLabel"
              >
                <template slot="option"  slot-scope="{ option }">{{ option.no_laporppl ? option.no_laporppl + ' - ' : option.no_lapor }} {{ option.nama_pelatihan ? option.nama_pelatihan + ' - ' : '' }}</template>
              </multiselect>
            </div>
          </div>
      </CRow>
      <CRow class="my-2">
        <router-link v-if="kategoriPelatihan == 'webinar' || kategoriPelatihan == 'offline'"
          :to="'/pelatihan/data-skp-peserta/kehadiran-peserta/'+pelatihan.id_workshop_pelatihan" class="ml-3 text-decoration-none">
          <button class="btn btn-block btn-success">Kehadiran Peserta</button>
        </router-link>
        <template v-if="role_status && role_status.status_export_excel">
        <button
          class="btn btn-md mx-3 btn-info"
          @click="downloadSKP(pelatihan.id_workshop_pelatihan)"
          >Download SKP Peserta</button>
        <input id="fileUpload" type="file" hidden @change="uploadFile">
        </template>
        <button class="btn btn-md text-white btn-warning" @click="chooseFiles()">
          Import SKP Peserta
        </button>
        <div class="ml-auto">
            <button class="btn btn-md btn-info mr-2">Reset Filter</button>
            <button type="button" class="btn btn-md btn-success mr-3" @click="filterData">Terapkan</button>
          </div>
      </CRow>
       <CRow>
        <div class="col-sm-12 col-xl-6" v-if="kategoriPelatihan != 'lms'">
          <label for="">Data Per Halaman</label>
          <div class="form-group">
            <CSelect
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>

        <div class="col-sm-12 col-xl-4 ml-auto" v-if="kategoriPelatihan != 'lms'">
          <div class="form-group">
            <CInput
              class="float-right"
              label="Pencarian"
              placeholder="Cari Data .."
              v-model="searchDataSKP"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive mt-2" v-if="kategoriPelatihan != 'lms'">
          <!-- fieldsLms -->
          <CDataTable
            style="widht:100% !important" 
            :items="items"
            :fields="fields "
            responsive
            hover
            sorter
          >
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
            </template>
            <template #skp_terstruktur="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.skp_terstruktur ? item.skp_terstruktur : '0' }}</td>
            </template>
            <template #nama_lengkap="{ item }" >
              <td class="py-2" v-if="item.tipe_peserta == 'moderator'">
                <span v-if="item.tipe_instruktur == 'IAPI'">{{ item.nama_lengkap ? item.nama_lengkap : "-" }}</span>
                <span v-else>{{ item.nama_instruktur ? item.nama_instruktur : "-" }}</span>
              </td>
              <td class="py-2" v-else-if="item.tipe_peserta == 'instruktur'">
                <span v-if="item.tipe_instruktur == 'IAPI'">{{ item.nama_lengkap ? item.nama_lengkap : "-" }}</span>
                <span v-else>{{ item.nama_instruktur ? item.nama_instruktur : "-" }}</span>
              </td>
              <td class="py-2" v-else>
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>
            <template #skp_tidak_terstruktur="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.skp_tidak_terstruktur ? item.skp_tidak_terstruktur : '0' }}</td>
            </template>
            <template #skp_assessment="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.skp_assessment ? item.skp_assessment : '0' }}</td>
            </template>
            <template #updated_at_skp="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.updated_at_skp ? item.updated_at_skp : '-' }}</td>
            </template>
            <template #nilai_post_test="{item}">
              <td class="py-2 text-center font-weight-bold">{{Math.floor(item.nilai_post_test) ? item.nilai_post_test : '0' }}</td>
            </template>
            <template #kategori_peserta="{item}">
              <td class="py-2 text-capitalize">{{item.kategori_peserta ? item.kategori_peserta : '-' }}</td>
            </template>
             <template #tipe_peserta="{ item }">
              <td class="py-2 text-capitalize" v-if="tipe_peserta == 'moderator'">
                {{ item.tipe_peserta ? item.tipe_peserta : "-" }}
              </td>
              <td class="py-2 text-capitalize" v-if="tipe_peserta == 'instruktur'">
                {{ item.tipe_peserta ? item.tipe_peserta : "-" }}
              </td>
              <td class="py-2 text-capitalize" v-else>
                {{ item.tipe_peserta ? item.tipe_peserta : "Peserta" }}
              </td>
            </template>
            
            <template #aksi="{item}">
              <td class="py-2 text-center">
                  <template v-if="role_status && role_status.status_update">
                    <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mr-2" square @click="edit(item)">
                      <font-awesome-icon icon="edit" />
                    </CButton>
                  </template>
                  <template v-else> 
                    <CButton v-c-tooltip="'Ubah'" color="secondary" class="btn-sm mr-2" square disabled>
                      <font-awesome-icon icon="edit" />
                    </CButton>
                  </template>
              </td>
            </template>
          </CDataTable>
         
          <CPagination
            style="float:right"
            :active-page.sync="currentPageDataSkp"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          /> 
          
        </CCol>
        <CCol lg="12" class="table-responsive mt-2" v-else>
        <CDataTable
            style="widht:100% !important" 
            :items="items"
            :fields="fieldsLms"
            hover
            sorter
            table-filter
            items-per-page-select
            pagination
          >
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
            </template>
            <template #skp_terstruktur="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.skp_terstruktur ? item.skp_terstruktur : '0' }}</td>
            </template>
            <template #nama_lengkap="{ item }" >
              <td class="py-2" v-if="item.tipe_peserta == 'moderator'">
                <span v-if="item.tipe_instruktur == 'IAPI'">{{ item.nama_lengkap ? item.nama_lengkap : "-" }}</span>
                <span v-else>{{ item.nama_instruktur ? item.nama_instruktur : "-" }}</span>
              </td>
              <td class="py-2" v-else-if="item.tipe_peserta == 'instruktur'">
                <span v-if="item.tipe_instruktur == 'IAPI'">{{ item.nama_lengkap ? item.nama_lengkap : "-" }}</span>
                <span v-else>{{ item.nama_instruktur ? item.nama_instruktur : "-" }}</span>
              </td>
              <td class="py-2" v-else>
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>
            <template #skp_tidak_terstruktur="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.skp_tidak_terstruktur ? item.skp_tidak_terstruktur : '0' }}</td>
            </template>
            <template #skp_assessment="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.skp_assessment ? item.skp_assessment : '0' }}</td>
            </template>
            <template #nilai_post_test="{item}">
              <td class="py-2 text-center font-weight-bold">{{Math.floor(item.nilai_post_test) ? item.nilai_post_test : '0' }}</td>
            </template>
            <template #kategori_peserta="{item}">
              <td class="py-2 text-capitalize">{{item.kategori_peserta ? item.kategori_peserta : '-' }}</td>
            </template>
             <template #tipe_peserta="{ item }">
              <td class="py-2 text-capitalize" v-if="tipe_peserta == 'moderator'">
                {{ item.tipe_peserta ? item.tipe_peserta : "-" }}
              </td>
              <td class="py-2 text-capitalize" v-if="tipe_peserta == 'instruktur'">
                {{ item.tipe_peserta ? item.tipe_peserta : "-" }}
              </td>
              <td class="py-2 text-capitalize" v-else>
                {{ item.tipe_peserta ? item.tipe_peserta : "Peserta" }}
              </td>
            </template>
            
            <template #aksi="{item}">
              <td class="py-2 text-center">
                  <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mr-2" square @click="edit(item)">
                    <font-awesome-icon icon="edit" />
                  </CButton>
              </td>
            </template>
          </CDataTable>
        </CCol>
      </CRow>
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Nama Peserta</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_kupon"
                      
                      readonly
                      v-model="formData.nama_lengkap"
                    />                    
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">SKP Terstruktur</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="SKP Terstruktur"
                      v-model="formData.skp_terstruktur"
                      min="0"
                    />                    
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">SKP Non Terstruktur</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="SKP Non Terstruktur"
                      v-model="formData.skp_tidak_terstruktur"
                      min="0"
                    />                    
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">SKP Assesment</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model="formData.skp_assessment"
                      placeholder="SKP Assesment"
                      min="0"
                    />
                  </div>
                </div>
                
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Edit</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postSkp" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import PelaporanSkpService from "@/services/keanggotaan/pelaporan-skp.service";
import KategoriAnggotaService from "@/services/keanggotaan/kategori-anggota.service";
import DataPesertaWebinarService from "@/services/pelatihan/data-peserta/data-peserta-webinar.service";
import WorkshopService from "@/services/pelatihan/workshop.service";
import dataPesertaLmsService from '@/services/pelatihan/data-peserta/data-peserta-lms.service';
import PeriodeService from '@/services/datamaster/periode.service';
import DataSkpPesertaService from "@/services/pelatihan/data-skp-peserta.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from '@/mixins/exportUtils';
import { Pagination } from "@/mixins/Pagination";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama Peserta",
    sorter: true,
    filter: true,
  },
  {
    key: "skp_terstruktur",
    label: "SKP Terstruktur",
    _style: 'text-align: center',
    sorter: true,
    filter: true,
  },
  {
    key: "skp_tidak_terstruktur",
    label: "SKP Tidak Terstruktur",
    _style: 'text-align: center',
    sorter: true,
    filter: true,
  },
  {
    key: "skp_assessment",
    label: "SKP Assesment",
    _style: 'text-align: center',
    sorter: true,
    filter: true,
  },
  {
    key: "updated_at_skp",
    label: "Tanggal SKP Diberikan",
    _style: 'text-align: center',
    sorter: true,
    filter: false,
  },
  {
    key: "nilai_post_test",
    label: "Nilai Post Test",
    _style: 'text-align: center',
    sorter: true,
    filter: false,
  },
  {
    key: "tipe_peserta",
    label: "Tipe Peserta",
    sorter: true,
    filter: false,
  },
  
  {
    key: "aksi",
    _style: "width:5%; text-align: center",
    sorter: false,
    filter: false,
  },
];

const fieldsLms = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama Peserta",
    sorter: true,
    filter: true,
  },
  {
    key: "skp_terstruktur",
    label: "SKP Terstruktur",
    _style: 'text-align: center',
    sorter: true,
    filter: true,
  },
  {
    key: "skp_tidak_terstruktur",
    label: "SKP Tidak Terstruktur",
    _style: 'text-align: center',
    sorter: true,
    filter: true,
  },
  {
    key: "skp_assessment",
    label: "SKP Assesment",
    _style: 'text-align: center',
    sorter: true,
    filter: true,
  },
  {
    key: "nilai_post_test",
    label: "Nilai Post Test",
    _style: 'text-align: center',
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width:15%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [AlertUtils, exportUtils, Pagination],
  data() {
    return {
      items: [],
      dataPelatihan: [],
      dataKategori: [],
      dataTahun: [],
      kategori: "",
      kategoriPelatihan: "",
      pelatihan: "",
      filename: 'Pilih File',
      fileToImport: '',
      formData: {
        nama_lengkap: '',
        nama_kategori: '',
        skp_terstruktur: '',
        skp_tidak_terstruktur: '',
        skp_assessment: '',
        tanggal_laporan: '',
        status: '',        
        id_pelatihan_peserta: '',
      },
      fields,
      fieldsLms,
      currentPageDataSkp: 0,
      pagination: {
        totalPages: 0
      },
      searchDataSKP: "",
      pageSize: "10",

      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  mounted() {
    $(function () {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
        },
        function (start, end, label) {
          // comment console console.log(
            
        }
      );
    });
    this.periode = [
      {
        labelPeriode: new Date().getFullYear(),
        value: new Date().getFullYear(),
      },
    ];
    this.getTahun();
    this.getKategori();
    this.getPeriode();
    this.roleData();
  },
  
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    customLabel({no_laporppl, no_lapor, nama_pelatihan}) {
      return `${no_laporppl ? no_laporppl : no_lapor} - ${nama_pelatihan}`;
    },

    postSkp() {
      this.myModal = false
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      var kategori = this.kategoriPelatihan;
      if(kategori == "offline" || kategori == "webinar") {
        
        DataSkpPesertaService.ubahSkpPeserta (this.formData)
          .then((response) => {
            this.getData(this.currentPageDataSkp - 1, this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
            this.alertSuccess()     
            loader.hide();
          })
          .catch((error) => {
            loader.hide();
            this.alertError(error)
          })
      }
      else if(kategori == "lms") {
        dataPesertaLmsService.ubahSkpPeserta (this.formData)
          .then((response) => {
            this.getData(this.currentPageDataSkp - 1, this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
            this.alertSuccess()     
            loader.hide();
          })
          .catch((error) => {
            loader.hide();
            this.alertError(error)
          })
      }
    },
    edit(item) {
      
      this.myModal = true;
      
      var kategori = this.kategoriPelatihan;
      if(kategori == "offline" || kategori == "webinar") {
        this.formData.id_pelatihan_peserta = item.id_pelatihan_peserta
      } else if(kategori == "lms") { 
        this.formData.id_pelatihan_peserta = item.id_enrolls
      }
      if(item.nama_lengkap == null || item.nama_lengkap == "" ) {
        this.formData.nama_lengkap = item.nama_instruktur
      } else {
        this.formData.nama_lengkap = item.nama_lengkap
      }
      this.formData.skp_terstruktur = item.skp_terstruktur 
      this.formData.skp_tidak_terstruktur = item.skp_tidak_terstruktur 
      this.formData.skp_assessment = item.skp_assessment 
    },
    uploadFile(e) {
      this.filename = e.target.files[0].name;
      this.fileToImport = e.target.files[0];
      this.importFile();
    },
    importFile() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
      onCancel: this.onCancel
      });
      var kategori = this.kategoriPelatihan;
      if(kategori == "offline" || kategori == "webinar") {
        DataSkpPesertaService.importDataSkpPeserta(this.fileToImport,this.pelatihan.id_workshop_pelatihan)
          .then((response) => {
            this.filename = 'Pilih File';
            this.fileToImport = '';
            this.getData(this.currentPageDataSkp - 1, this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
            this.alertSuccess(response.data.message)     
            loader.hide();
          })
          .catch((error) => {
            loader.hide();
            this.alertError(error.response.data.message)
          })
        }
        else if(kategori == "lms") { 
           dataPesertaLmsService.importDataSkpPeserta(this.fileToImport)
          .then((response) => {
            this.filename = 'Pilih File';
            this.fileToImport = '';
            this.getData(this.currentPageDataSkp - 1, this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
            this.alertSuccess(response.data.message)     
            loader.hide();
          })
          .catch((error) => {
            loader.hide();
            this.alertError(error)
          }) 
        }
    },
    downloadSKP(value) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      var kategori = this.kategoriPelatihan;
      if(kategori == "offline" || kategori == "webinar") {
        DataSkpPesertaService.downloadSKP(value)
          .then(response => {
            loader.hide()
            this.exportData(response.data, 'Data-Skp-Peserta-Pelatihan');
            this.alertExportSuccess();
            this.getData("0", this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
          })
          .catch(error => {
          this.alertExportFailed();
          this.getData("0", this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
        })
      } else if(kategori == "lms") {
        dataPesertaLmsService.downloadSKP(value)
          .then(response => {
            loader.hide()
            this.exportData(response.data, 'Data-Skp-Peserta-Pelatihan');
            this.alertExportSuccess();
            this.getData("0", this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
          })
        .catch(error => {
          this.alertExportFailed();
          this.getData("0", this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
        })
      }
    },
    getPelatihan() {
      var vm = this;
      var kategori = vm.kategoriPelatihan;
      if(kategori == "webinar") {
        WorkshopService.getWebinar(0,1000000,'default','default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      } else if(kategori == "offline") {
        WorkshopService.getWorkshop(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content;
        })
      } else if(kategori == "lms") {
        dataPesertaLmsService.getPelatihan(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data;
          vm.dataPelatihan.nama_pelatihan = response.data.title; 
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      }
    },
    chooseFiles: function() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin mengimport data?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            document.getElementById("fileUpload").click()
          } else if (result.dismiss === Swal.DismissReason.cancel) {
           
          }
        });
    },
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            PelaporanSkpService.deletePelaporanSkp(this.formData)
              .then((response) => {
                // comment console console.log(response);
                this.alertDeleteSuccess();

                this.getData("0", this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
              })

              .catch((error) => {
                this.alertError();
                // comment console console.log(error);
              });
            Toast.fire({
              icon: "cancel",
              title: "Data Berhasil Dihapus",
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    
    getData(currentPageDataSkp, pageSize, idWorkshopPelatihan, filter) {
      var vm = this;
      var kategori = vm.kategoriPelatihan;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      if(kategori == "offline") {
        
        DataPesertaWebinarService.getDataPesertaOfflineSkp(
          currentPageDataSkp,
          pageSize,
          idWorkshopPelatihan,
          filter
        )
          .then(response => {
            loader.hide()
            vm.items = response.data.data.content;
            vm.pagination.totalPages = response.data.data.totalPages;
            vm.currentPageDataSkp = response.data.data.pageable.pageNumber + 1;
          })
          .catch(error => {
            loader.hide()
            // comment console console.log(error);
          });
      } else if(kategori == "webinar"){
        DataPesertaWebinarService.getDataPesertaSkp(
          currentPageDataSkp,
          pageSize,
          idWorkshopPelatihan,
          filter
        )
          .then(response => {
            loader.hide()
            

            vm.items = response.data.data.content;
            vm.pagination.totalPages = response.data.data.totalPages;
            vm.currentPageDataSkp = response.data.data.pageable.pageNumber + 1;
          })
          .catch(error => {
            loader.hide()
            // comment console console.log(error);
          })
      } else if(kategori == "lms"){
        dataPesertaLmsService.getDataPeserta(
          currentPageDataSkp + 1,
          pageSize,
          idWorkshopPelatihan,
          filter
        )
          .then(response => {
            loader.hide()

            vm.items = response.data;
            // vm.pagination.totalPages = response.data.last_page;
            // vm.currentPageDataSkp = response.data.current_page;
          })
          .catch(error => {
            loader.hide()
            // comment console console.log(error);
          });
      }
    },

    getTahun() {
      PeriodeService.getPeriodeSelect()
        .then((response) => {
          this.dataTahun = response.data.data;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getKategori() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then((response) => {
          this.dataKategori = response.data.data.content;
          this.kategori = this.dataKategori[0];
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getPeriode() {      
      PeriodeService.getPeriodeSelect()
        .then(response => {          
          this.dataPeriode = response.data.data
          this.periode = this.dataPeriode.find(el => el.status === "1");          
        })
        .catch(error => {          
          // comment console console.log(error)          
        })      
    },

    changeKategori(val) {
      this.kategori = val;      
    },
     
    changePeriode(val) {      
      this.periode = val;
    },

    changePageSize(e) {    
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
    },

    pageChange() {
      var kategori = this.kategoriPelatihan;
      if(kategori == 'webinar' || kategori == 'offline') {
        this.getData(this.currentPageDataSkp, this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
      }
      else if(kategori == 'lms') {
      this.getData(this.currentPageDataSkp, this.pageSize, this.searchDataSKP);
      }
    },

    filterData() {
      this.getData("0", this.pageSize, this.pelatihan.id_workshop_pelatihan, this.searchDataSKP);
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
